<template>
	<q-list class="q-mb-md">
		<q-collapsible icon="fal fa-filter" v-model="open" @click="toggle" :label="getNameFilter">
			<div class="row gutter-sm" v-if="options">
				<div class="col-xs-12 col-sm-12" v-if="options.areas">
					<select-multiple
						label="areas"
						:filters="filters.area"
						:options="options.areas"
						@on_value="filters.area = $event"
					/>
				</div>

				<div class="col-xs-12 col-sm-12" v-if="options.profiles">
					<q-select
						v-model="filters.profile"
						chips
						:options="options.profiles"
						multiple
						:float-label="$t('profiles')"
						clearable
					/>
				</div>

				<div class="col-xs-12 col-sm-12" v-if="options.user_groups">
					<q-select
						v-model="filters.user_group"
						chips
						:options="options.user_groups"
						multiple
						:float-label="$t('groups')"
						clearable
					/>
				</div>

				<div class="col-xs-12 col-sm-12" v-if="options.statuses">
					<q-select
						chips
						multiple
						v-model="filters.status"
						:options="options.statuses"
						:float-label="$t('status')"
						clearable
					/>
				</div>

				<div class="col-xs-12 col-sm-12" v-if="options.categories && showFilterCategories">
					<q-select
						chips
						multiple
						v-model="filters.category"
						:options="options.categories"
						:float-label="$t('categories')"
						clearable
					/>
				</div>

				<div class="col-xs-12 col-sm-12" v-if="options.tags">
					<q-select
						chips
						multiple
						v-model="filters.tag"
						:options="options.tags"
						:float-label="$t('tags')"
						clearable
					/>
				</div>

				<div class="col-xs-12 col-sm-6 gutter">
					<q-datetime
						v-model="filters.start_date_display"
						:float-label="$t('creation_date_from')"
						type="datetime"
						format="DD/MM/YYYY HH:mm"
						clearable
					/>
				</div>

				<div class="col-xs-12 col-sm-6 gutter">
					<q-datetime
						v-model="filters.end_date_display"
						:float-label="$t('creation_date_to')"
						type="datetime"
						format="DD/MM/YYYY HH:mm"
						clearable
					/>
				</div>
			</div>
			<div class="row gutter-sm justify-end q-mt-sm">
				<div class="col-xs-12 col-sm-3">
					<q-btn
						color="negative"
						class="full-width"
						:label="$t('clear_filters')"
						icon="far fa-eraser"
						@click="clearFilter()"
					/>
				</div>
				<div class="col-xs-12 col-sm-3">
					<q-btn
						color="secondary"
						class="full-width"
						:label="$t('apply_filter_plural')"
						icon="far fa-filter"
						@click="requestFiltered()"
					/>
				</div>
			</div>
		</q-collapsible>
	</q-list>
</template>

<script>
import { mapGetters } from 'vuex'
import { date } from 'quasar'
const { formatDate } = date
import SelectMultiple from 'components/utils/SelectMultiple'
export default {
	props: ['options'],
	data() {
		return {
			open: false,
			filters: {
				area: [],
				status: [],
				profile: [],
				user_group: [],
				category: [],
				tag: [],
				start_date: [],
				start_date_display: '',
				end_date: [],
				end_date_display: '',
			},
		}
	},
	components: {
		'select-multiple': SelectMultiple,
	},

	computed: {
		...mapGetters({
			access_token: 'common/access_token',
			trails_filters: 'admin_filters/trails_filters',
			clients: 'params/clients',
			id_user_client_selected: 'common/id_user_client_selected',
		}),

		getHeader() {
			let headers = {}
			return (headers = {
				headers: {
					'content-type': 'application/json',
					authorization:
						'Basic ' +
						btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
					authorization: 'Bearer ' + this.access_token,
				},
			})
		},

		getNameFilter() {
			if (Object.entries(this.filters).find((a) => a[1] && a[1].length > 0)) {
				return `${this.$t('filter')} <i class="far fa-exclamation-circle"></i>`
			} else return this.$t('filter')
		},

		showFilterCategories() {
			let client = this.clients.find((obj) => obj.id === this.id_user_client_selected)
			if (client) return client.has_trail_category
			return false
		}
	},

	methods: {
		requestFiltered() {
			this.$emit('requestFiltered', {
				area: this.filters.area,
				profile: this.filters.profile,
				user_group: this.filters.user_group,
				status: this.filters.status,
				tag: this.filters.tag,
				start_date: [
					date.formatDate(this.filters.start_date_display, 'YYYY-MM-DD-HH-mm-ss'),
				],
				end_date: [date.formatDate(this.filters.end_date_display, 'YYYY-MM-DD-HH-mm-ss')],
				category: this.filters.category,
			})
			this.saveTrailsFilters()
			setTimeout(() => {
				this.toggle()
			}, 500)
		},

		clearFilter() {
			this.filters.area = []
			this.filters.status = []
			this.filters.profile = []
			this.filters.user_group = []
			this.filters.category = []
			;(this.filters.tag = []),
				(this.filters.start_date = []),
				(this.filters.start_date_display = '')
			this.filters.end_date = []
			this.filters.end_date_display = ''
			this.$emit('clearAndRequest')
			this.clearStoredFilters()
			setTimeout(() => {
				this.toggle()
			}, 500)
		},

		toggle() {
			this.open = !this.open
		},

		saveTrailsFilters() {
			this.$store.dispatch('admin_filters/SET_TRAILS_FILTERS', {
				trails_filters: this.filters,
			})
		},

		loadTrailsFilters() {
			this.filters = this.trails_filters
			setTimeout(() => {
				this.requestFiltered()
			}, 1000)
		},

		clearStoredFilters() {
			this.$store.dispatch('admin_filters/SET_TRAILS_FILTERS', { trails_filters: {} })
		},
	},

	mounted() {
		if (this.trails_filters && this.trails_filters.status) {
			this.loadTrailsFilters()
		}
	},
}
</script>

<style></style>
